import type { SamplingArea } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

export const getUncroppedFeatures = ({ features }: { features: SamplingArea[] }) =>
  features.map(feature => ({
    ...feature,
    geometry: feature.uncroppedGeometry,
    toGeoJSON: feature.toUncroppedGeoJSON,
  }))

export const getSamplingAreasByFarm = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<SamplingArea[]> => {
  const response = await apiClient.get(endpoints.samplingAreas, { params: { farmId }, signal })
  return [...unwrapCollection<SamplingArea>(response)].sort((a, b) =>
    (a?.name ?? '').localeCompare(b?.name ?? ''),
  )
}

// Compatibility shim for the last call site not yet migrated to useSamplingAreas
// (getMapaToDownload).
export const getUncroppedSamplingAreasByFarm = async ({ farmId }: { farmId: string }) =>
  getUncroppedFeatures({ features: await getSamplingAreasByFarm({ farmId }) })
